<template>
  <v-card class="mb-4" outlined>
    <v-card-title class="section-header">
      <v-icon left color="grey darken-1">mdi-silverware-variant</v-icon>
      {{ $t("menu_type") }}
    </v-card-title>
    <v-card-text class="pt-4">
      <v-row align="center">
        <v-col cols="12" sm="6">
          <autocomplete
            v-if="restaurant"
            :value="selectedId"
            :items="typeItems"
            :label="$t('available_menu_type_for_comp')"
            item-text="filteredName"
            item-value="id"
            :required="canEdit"
            :readonly="!canEdit"
            @input="onPick"
          />
          <v-alert
            v-if="typeUnavailable"
            type="warning"
            text
            dense
            class="mt-2 mb-0 caption"
          >
            {{ $t("selected_menu_type_unavailable") }}
          </v-alert>
        </v-col>
        <v-col cols="12" sm="6">
          <v-checkbox
            v-model="restaurant.company_restaurant_settings.everyday_offer"
            :false-value="0"
            :true-value="1"
            color="#FF6B35"
            dense
            no-gutters
            class="mt-5"
            hide-details
            :label="$t('everyday_offer')"
          >
          </v-checkbox>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
/**
 * Tip jelovnika koji je firmi dostupan kod ovog restorana. Lista dolazi sa servera uz sam restoran
 * (`restaurant.menu_types`: opšti tipovi + tipovi tog restorana), a izabrani tip je `restaurant.menu_types_id`.
 * Tip se veže po ID-u, nikad po nazivu. Ako izabrani tip nije u listi (npr. obrisan), polje ostaje prazno uz
 * upozorenje i ništa se ne šalje dok korisnik sam ne izabere novi.
 */
export default {
  name: "MenuTypeCard",
  props: {
    restaurant: {
      type: Object,
      default: null,
    },
    company: {
      type: Object,
      default: null,
    },
    /** ID koji je korisnik izabrao u ovoj kartici; null dok ga nije dirao */
    pickedId: {
      type: Number,
      default: null,
    },
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    },
    /** Tip snimaju samo administrator sistema i restoran; administrator firme ga samo vidi (inače dobija 403). */
    canEdit() {
      return ["admin", "restaurant"].includes(this.user?.type);
    },
    typeItems() {
      return (this.restaurant?.menu_types || []).map((type) => ({
        ...type,
        // Opšti tipovi imaju prevod, tipovi restorana su slobodan tekst
        filteredName: type.restaurant_id == null ? this.$t(type.name) || type.name : type.name,
      }));
    },
    /** Trenutno važeći tip sa servera (veza ovog restorana sa firmom) */
    savedId() {
      const id = this.restaurant?.menu_types_id ?? this.restaurant?.company_restaurant_settings?.menu_types_id;
      return id == null || id === "" ? null : Number(id);
    },
    savedInList() {
      return this.savedId != null && this.typeItems.some((type) => type.id === this.savedId);
    },
    selectedId() {
      if (this.pickedId != null) {
        return this.pickedId;
      }
      return this.savedInList ? this.savedId : null;
    },
    typeUnavailable() {
      return this.pickedId == null && this.savedId != null && !this.savedInList;
    },
  },
  methods: {
    onPick(id) {
      if (id == null || id === "") {
        return;
      }
      this.$emit("pick", Number(id));
    },
  },
};
</script>

<style scoped>
.section-header {
  font-size: 0.95rem;
  font-weight: 500;
  padding: 12px 16px;
  background: #fafafa;
  border-bottom: 1px solid #eee;
}
</style>
